import { atom } from "jotai";
import type { Getter, Setter } from "jotai";

// Atom to track which health areas are currently having a routine suggested
export const routineSuggestionLoadingAtom = atom<Record<string, boolean>>({});

// Helper functions to get and set loading state for a specific health area
export const getRoutineSuggestionLoading = (get: Getter, healthAreaId: string): boolean => {
  return get(routineSuggestionLoadingAtom)[healthAreaId] ?? false;
};

export const setRoutineSuggestionLoading = (
  get: Getter,
  set: Setter,
  healthAreaId: string,
  loading: boolean,
): void => {
  const current = get(routineSuggestionLoadingAtom);
  set(routineSuggestionLoadingAtom, {
    ...current,
    [healthAreaId]: loading,
  });
};
